import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=484d99d3&scoped=true&"
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order-detail.vue?vue&type=style&index=1&id=484d99d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d99d3",
  null
  
)

export default component.exports